import type {
  CrudFormItem,
  CrudSearchItem,
  CrudSelectOption,
  CrudTableColumn
} from '@/types/crud-config'
import type { ProductPayload, ProductRecord } from './product.service'

export type ProductForm = ProductPayload

const showOptions: CrudSelectOption[] = [
  { label: '全部', value: '' },
  { label: '是', value: '1' },
  { label: '否', value: '0' }
]

export function createProductSearchItems(
  liveRoomOptions: CrudSelectOption[]
): CrudSearchItem[] {
  return [
    {
      label: '所属直播间',
      prop: 'liveRoom',
      type: 'select',
      controlClass: 'product-page__search-control',
      clearable: true,
      placeholder: '请选择直播间',
      options: liveRoomOptions
    },
    {
      label: '商品名称',
      prop: 'name',
      type: 'input',
      controlClass: 'product-page__search-control',
      clearable: true,
      placeholder: '请输入商品名称'
    },
    {
      label: '是否上架',
      prop: 'isShow',
      type: 'select',
      controlClass: 'product-page__search-control',
      clearable: true,
      placeholder: '请选择上架状态',
      options: showOptions
    }
  ]
}

export function createProductFormItems(
  liveRoomOptions: CrudSelectOption[]
): CrudFormItem<ProductForm>[] {
  const priceFields: Array<{
    prop: keyof ProductForm
    label: string
    placeholder: string
  }> = [
    { prop: 'monthPrice', label: '1个月价格', placeholder: '请输入1个月价格' },
    {
      prop: 'twoMonthPrice',
      label: '2个月价格',
      placeholder: '请输入2个月价格'
    },
    {
      prop: 'threeMonthPrice',
      label: '季度价格',
      placeholder: '请输入季度价格'
    },
    {
      prop: 'fourMonthPrice',
      label: '4个月价格',
      placeholder: '请输入4个月价格'
    },
    {
      prop: 'fiveMonthPrice',
      label: '5个月价格',
      placeholder: '请输入5个月价格'
    },
    {
      prop: 'sixMonthPrice',
      label: '半年价格',
      placeholder: '请输入半年价格'
    },
    { prop: 'yearPrice', label: '年度价格', placeholder: '请输入年度价格' },
    { prop: 'deposit', label: '定金', placeholder: '请输入定金' }
  ]

  return [
    {
      label: '商品名称',
      prop: 'name',
      type: 'input',
      clearable: true,
      placeholder: '请输入商品名称'
    },
    ...priceFields.map(({ prop, label, placeholder }) => ({
      label,
      prop,
      type: 'slot' as const,
      slot: 'number',
      placeholder
    })),
    {
      label: '商品链接',
      prop: 'buyLink',
      type: 'input',
      clearable: true,
      placeholder: '请输入商品链接'
    },
    {
      label: '所属直播间',
      prop: 'liveRoom',
      type: 'select',
      clearable: true,
      placeholder: '请选择直播间',
      options: liveRoomOptions
    }
  ]
}

export function createProductTableColumns(
  showActions: boolean
): CrudTableColumn<ProductRecord>[] {
  const columns: CrudTableColumn<ProductRecord>[] = [
    { prop: 'liveRoom', label: '所属直播间', slot: 'liveRoom', minWidth: 130 },
    {
      prop: 'name',
      label: '商品名称',
      minWidth: 140,
      showOverflowTooltip: true
    },
    { prop: 'cover', label: '商品图片', slot: 'cover', minWidth: 120 },
    { prop: 'price', label: '商品价格', minWidth: 100 },
    {
      prop: 'payQrCode',
      label: '支付二维码',
      slot: 'payQrCode',
      minWidth: 120
    },
    { prop: 'isShow', label: '是否上架', slot: 'isShow', minWidth: 90 },
    { prop: 'hotSell', label: '上热卖', slot: 'hotSell', minWidth: 90 },
    {
      prop: 'updateTime',
      label: '更新时间',
      minWidth: 170,
      showOverflowTooltip: true
    }
  ]

  if (showActions) {
    columns.push({
      label: '操作',
      slot: 'rowActions',
      width: 150,
      fixed: 'right'
    })
  }
  return columns
}
